import { ParamsProps, ReturnType } from "./types";
import request from "@utils/request";

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "wallet-loads",
      method: "get",
      authorization: true,
      params: args?.params,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const requestLoad = async (args: { data: any }) => {
  try {
    const config: ReturnType = {
      url: "wallet-loads",
      method: "post",
      authorization: true,
      data: args.data,
      config: {

      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const initiateKhalti = async (args: { data: { amount: number } }) => {
  try {
    const config: ReturnType = {
      url: "wallet-loads/khalti/initiate",
      method: "post",
      authorization: true,
      data: args.data,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const initiateEsewa = async (args: { data: { amount: number } }) => {
  try {
    const config: ReturnType = {
      url: "wallet-loads/esewa/initiate",
      method: "post",
      authorization: true,
      data: args.data,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const approve = async (args: { id: number; data: any }) => {
  try {
    const config: ReturnType = {
      url: `wallet-loads/${args.id}/approve`,
      method: "post",
      authorization: true,
      data: args.data,
      config: {
        successMsg: "Wallet load approved successfully",
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const reject = async (args: { id: number; data: any }) => {
  try {
    const config: ReturnType = {
      url: `wallet-loads/${args.id}/reject`,
      method: "post",
      authorization: true,
      data: args.data,
      config: {
        successMsg: "Wallet load rejected successfully",
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const directCredit = async (args: { data: any }) => {
  try {
    const config: ReturnType = {
      url: "wallet-loads/direct-credit",
      method: "post",
      authorization: true,
      data: args.data,
      config: {
        successMsg: "Wallet credited successfully",
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const directDebit = async (args: { data: any }) => {
  try {
    const config: ReturnType = {
      url: "wallet-loads/direct-debit",
      method: "post",
      authorization: true,
      data: args.data,
      config: {
        successMsg: "Wallet debited successfully",
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  list,
  requestLoad,
  initiateKhalti,
  initiateEsewa,
  approve,
  reject,
  directCredit,
  directDebit,
};
